(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["g2g-midyear-coupon"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('g2g-coupon-character')) {
    const storageKey = 'g2g-coupon-character:last-source';
    let lastSource = null;

    customElements.define('g2g-coupon-character', class extends HTMLElement {
      connectedCallback() {
        this.onPageShow ||= (event) => {
          if (event.persisted) this.selectCharacter();
        };
        window.addEventListener('pageshow', this.onPageShow);
        queueMicrotask(() => {
          if (this.isConnected) this.selectCharacter();
        });
      }

      disconnectedCallback() {
        window.removeEventListener('pageshow', this.onPageShow);
      }

      selectCharacter() {
        const image = this.querySelector('.g2g-midyear-coupon__character');
        if (!image) return;

        let sources;
        try {
          sources = JSON.parse(this.dataset.sources || '[]');
        } catch {
          return;
        }
        if (!Array.isArray(sources)) return;
        sources = [...new Set(sources.filter((source) => typeof source === 'string' && source.length > 0))];
        if (sources.length === 0) return;

        let previousSource = this.lastSource || lastSource;
        try {
          previousSource = this.lastSource || sessionStorage.getItem(storageKey) || previousSource;
        } catch {}

        const candidates = sources.length > 1
          ? sources.filter((source) => source !== previousSource)
          : sources;
        const source = candidates[Math.floor(Math.random() * candidates.length)];
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = source;
        this.lastSource = source;
        lastSource = source;
        try {
          sessionStorage.setItem(storageKey, source);
        } catch {}
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-promo-banner"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-promo-banner')) {
    customElements.define('product-promo-banner', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        const track = this.querySelector('.pdp-promo__track');
        const controls = this.querySelector('.pdp-promo__controls');
        if (!track || !controls) return;
        const slides = [...track.children];
        const count = this.querySelector('.pdp-promo__count');
        const activeIndex = () => {
          const trackRect = track.getBoundingClientRect();
          const rtl = getComputedStyle(track).direction === 'rtl';
          const edge = rtl ? 'right' : 'left';
          let closest = 0;
          let distance = Infinity;
          slides.forEach((slide, index) => {
            const delta = Math.abs(slide.getBoundingClientRect()[edge] - trackRect[edge]);
            if (delta < distance) { closest = index; distance = delta; }
          });
          return closest;
        };
        const update = () => { count.textContent = `${activeIndex() + 1} / ${slides.length}`; };
        controls.hidden = false;
        controls.addEventListener('click', (event) => {
          const button = event.target.closest('button[data-direction]');
          if (!button) return;
          const next = (activeIndex() + Number(button.dataset.direction) + slides.length) % slides.length;
          const rtl = getComputedStyle(track).direction === 'rtl';
          const edge = rtl ? 'right' : 'left';
          const delta = slides[next].getBoundingClientRect()[edge] - track.getBoundingClientRect()[edge];
          track.scrollBy({ left: delta, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, { signal });
        track.addEventListener('scroll', update, { passive: true, signal });
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(track);
        update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-certification-numbers"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('variant-certification-numbers')) {
    customElements.define('variant-certification-numbers', class extends HTMLElement {
      connectedCallback() {
        const data = this.querySelector('[data-variant-certification-data]');
        if (!data) return;

        try {
          this.numbersByVariant = JSON.parse(data.textContent);
        } catch (error) {
          return;
        }

        this.onVariantChanged = this.onVariantChanged.bind(this);
        document.addEventListener('variant:changed', this.onVariantChanged);
      }

      disconnectedCallback() {
        if (this.onVariantChanged) {
          document.removeEventListener('variant:changed', this.onVariantChanged);
        }
      }

      onVariantChanged(event) {
        if (event.target.getAttribute('id') !== this.getAttribute('form-id')) return;

        const variant = event.detail && event.detail.variant;
        const variantId = variant && variant.id;
        const numbers = this.numbersByVariant[String(variantId)] || {};
        let hasNumber = false;

        for (const type of ['halal', 'bpom']) {
          const row = this.querySelector(`[data-certification-row="${type}"]`);
          const value = row.querySelector(`[data-certification-value="${type}"]`);
          const number = numbers[type] == null ? '' : String(numbers[type]).trim();

          value.textContent = number;
          row.hidden = number === '';
          if (number !== '') hasNumber = true;
        }

        this.hidden = !hasNumber;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
